import type { Comic } from "@/types/comic";

export const comics: Comic[] = [
  {
    id: "jm001",
    title: "苍穹焰纪",
    author: "北川 燎",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20young%20male%20warrior%20with%20flaming%20sword%20standing%20on%20a%20floating%20sky%20city%2C%20warm%20orange%20and%20deep%20navy%20color%20scheme%2C%20bold%20shapes%2C%20clean%20minimal%20gradient%20background%2C%20high%20contrast%2C%20digital%20art&width=600&height=800&seq=jm-cover-01&orientation=portrait",
    categories: ["rexue", "maoxian"],
    region: "日本",
    status: "连载中",
    year: 2023,
    updateDate: "2024-06-18",
    downloads: 128430,
    rating: 9.4,
    summary: "少年焰司登上浮空城，以燃烧的意志对抗吞噬天空的巨兽。一场关于勇气、伙伴与牺牲的宏大冒险就此拉开序幕。",
    tags: ["少年", "冒险", "长更"],
    chapters: [
      { id: "jm001-5", title: "第 05 卷 天穹之约", format: "ZIP", size: "182 MB", date: "2024-06-18" },
      { id: "jm001-4", title: "第 04 卷 灰烬之塔", format: "ZIP", size: "176 MB", date: "2024-04-02" },
      { id: "jm001-3", title: "第 03 卷 浮空港之争", format: "ZIP", size: "168 MB", date: "2024-01-21" },
      { id: "jm001-2", title: "第 02 卷 巨兽的阴影", format: "PDF", size: "94 MB", date: "2023-11-09" },
      { id: "jm001-1", title: "第 01 卷 焰之继承者", format: "ZIP", size: "154 MB", date: "2023-09-14" },
    ],
  },
  {
    id: "jm002",
    title: "星海逐光者",
    author: "陆清野",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20female%20astronaut%20looking%20at%20a%20glowing%20nebula%2C%20spaceship%20silhouette%2C%20teal%20and%20amber%20gradient%2C%20clean%20minimal%20cosmic%20background%2C%20bold%20shapes%2C%20digital%20art&width=600&height=800&seq=jm-cover-02&orientation=portrait",
    categories: ["kehuan", "maoxian"],
    region: "中国",
    status: "连载中",
    year: 2022,
    updateDate: "2024-05-30",
    downloads: 96420,
    rating: 9.1,
    summary: "银河边缘的信号唤醒了沉睡的飞船，一支临时组建的探索队踏上寻找失落文明的旅程，却发现宇宙比想象中更冷酷。",
    tags: ["星际", "机甲", "群像"],
    chapters: [
      { id: "jm002-4", title: "第 04 卷 静默信标", format: "ZIP", size: "205 MB", date: "2024-05-30" },
      { id: "jm002-3", title: "第 03 卷 环带迷航", format: "ZIP", size: "198 MB", date: "2024-02-11" },
      { id: "jm002-2", title: "第 02 卷 深空回声", format: "PDF", size: "102 MB", date: "2023-10-05" },
      { id: "jm002-1", title: "第 01 卷 出发吧，逐光", format: "ZIP", size: "167 MB", date: "2023-07-19" },
    ],
  },
  {
    id: "jm003",
    title: "樱色恋爱手札",
    author: "小林 澪",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20two%20high%20school%20students%20sharing%20an%20umbrella%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20white%20palette%2C%20clean%20minimal%20background%2C%20romantic%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-03&orientation=portrait",
    categories: ["lianai", "xiaoyuan"],
    region: "日本",
    status: "已完结",
    year: 2021,
    updateDate: "2023-08-12",
    downloads: 87450,
    rating: 8.9,
    summary: "转学生与图书委员的相遇，从一本被遗忘的笔记本开始。细腻的青春悸动，藏在一整个春天的樱色里。",
    tags: ["青春", "治愈", "已完结"],
    chapters: [
      { id: "jm003-3", title: "第 03 卷 毕业那天", format: "ZIP", size: "143 MB", date: "2023-08-12" },
      { id: "jm003-2", title: "第 02 卷 雨中的伞", format: "ZIP", size: "139 MB", date: "2023-05-06" },
      { id: "jm003-1", title: "第 01 卷 笔记本的主人", format: "PDF", size: "88 MB", date: "2023-02-14" },
    ],
  },
  {
    id: "jm004",
    title: "夜莺侦探社",
    author: "서지우",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20detective%20in%20a%20rainy%20neon%20alley%20holding%20a%20magnifying%20glass%2C%20moody%20indigo%20and%20amber%20lighting%2C%20clean%20minimal%20background%2C%20bold%20shapes%2C%20digital%20art&width=600&height=800&seq=jm-cover-04&orientation=portrait",
    categories: ["xuanyi"],
    region: "韩国",
    status: "连载中",
    year: 2024,
    updateDate: "2024-09-27",
    downloads: 72310,
    rating: 9.2,
    summary: "一座被雨水浸透的城市，一桩无人愿意追查的旧案。夜莺侦探社的三位成员，用逻辑与直觉撕开谎言的面具。",
    tags: ["推理", "反转", "都市"],
    chapters: [
      { id: "jm004-4", title: "第 04 卷 雨夜证词", format: "ZIP", size: "189 MB", date: "2024-09-27" },
      { id: "jm004-3", title: "第 03 卷 无面者", format: "ZIP", size: "181 MB", date: "2024-07-15" },
      { id: "jm004-2", title: "第 02 卷 第七个证人", format: "PDF", size: "96 MB", date: "2024-05-03" },
      { id: "jm004-1", title: "第 01 卷 第一声夜啼", format: "ZIP", size: "158 MB", date: "2024-02-20" },
    ],
  },
  {
    id: "jm005",
    title: "异界食堂物语",
    author: "南 灯",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20cozy%20fantasy%20tavern%20with%20steaming%20bowls%20and%20a%20friendly%20chef%2C%20warm%20amber%20and%20cream%20palette%2C%20clean%20minimal%20background%2C%20inviting%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-05&orientation=portrait",
    categories: ["qihuan", "richang"],
    region: "日本",
    status: "连载中",
    year: 2023,
    updateDate: "2024-08-08",
    downloads: 65980,
    rating: 8.8,
    summary: "通往异界的门每晚只在午夜开启。一碟热腾腾的家常菜，能让巨龙、精灵与旅人都放下戒备，说出自己的故事。",
    tags: ["美食", "治愈", "异世界"],
    chapters: [
      { id: "jm005-3", title: "第 03 卷 精灵的甜点", format: "ZIP", size: "152 MB", date: "2024-08-08" },
      { id: "jm005-2", title: "第 02 卷 巨龙的晚餐", format: "ZIP", size: "147 MB", date: "2024-05-19" },
      { id: "jm005-1", title: "第 01 卷 午夜开门", format: "PDF", size: "85 MB", date: "2024-03-01" },
    ],
  },
  {
    id: "jm006",
    title: "拳皇学院",
    author: "김태현",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20two%20teen%20fighters%20facing%20off%20in%20a%20school%20gym%2C%20dynamic%20action%20poses%2C%20red%20and%20charcoal%20palette%2C%20clean%20minimal%20background%2C%20high%20energy%2C%20digital%20art&width=600&height=800&seq=jm-cover-06&orientation=portrait",
    categories: ["rexue", "xiaoyuan"],
    region: "韩国",
    status: "连载中",
    year: 2022,
    updateDate: "2024-07-22",
    downloads: 81260,
    rating: 8.6,
    summary: "表面上平凡的高中，地下却是全国格斗新星的摇篮。菜鸟新生要用拳头证明，天赋之外还有不肯认输的执念。",
    tags: ["格斗", "校园", "热血"],
    chapters: [
      { id: "jm006-4", title: "第 04 卷 社团对抗赛", format: "ZIP", size: "175 MB", date: "2024-07-22" },
      { id: "jm006-3", title: "第 03 卷 新星登场", format: "ZIP", size: "169 MB", date: "2024-04-18" },
      { id: "jm006-2", title: "第 02 卷 第一堂实战课", format: "PDF", size: "91 MB", date: "2024-01-30" },
      { id: "jm006-1", title: "第 01 卷 入部申请书", format: "ZIP", size: "160 MB", date: "2023-10-12" },
    ],
  },
  {
    id: "jm007",
    title: "月影魔术师",
    author: "柳 知遥",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20elegant%20magician%20casting%20glowing%20spell%20circle%20under%20a%20full%20moon%2C%20deep%20purple%20and%20silver%20accents%2C%20clean%20minimal%20background%2C%20mystical%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-07&orientation=portrait",
    categories: ["qihuan"],
    region: "中国",
    status: "已完结",
    year: 2020,
    updateDate: "2023-03-16",
    downloads: 94730,
    rating: 9.0,
    summary: "月圆之夜，魔术师能借用月亮的力量。当他被卷入一场跨越百年的魔法战争，才明白真正的魔术是用谎言守护真相。",
    tags: ["魔法", "长篇", "已完结"],
    chapters: [
      { id: "jm007-3", title: "第 03 卷 月蚀之约", format: "ZIP", size: "188 MB", date: "2023-03-16" },
      { id: "jm007-2", title: "第 02 卷 银币戏法", format: "ZIP", size: "178 MB", date: "2022-12-04" },
      { id: "jm007-1", title: "第 01 卷 无名的学徒", format: "PDF", size: "99 MB", date: "2022-09-01" },
    ],
  },
  {
    id: "jm008",
    title: "心跳节奏",
    author: "藤原 依",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20girl%20playing%20electric%20guitar%20on%20a%20school%20rooftop%20at%20sunset%2C%20coral%20and%20cream%20palette%2C%20clean%20minimal%20background%2C%20energetic%20romantic%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-08&orientation=portrait",
    categories: ["lianai"],
    region: "日本",
    status: "连载中",
    year: 2024,
    updateDate: "2024-10-02",
    downloads: 58240,
    rating: 8.7,
    summary: "为了守住快要解散的轻音社，内向的主唱和冷淡的吉他手不得不成为搭档。音乐响起的瞬间，心跳也失去了节奏。",
    tags: ["音乐", "青春", "甜"],
    chapters: [
      { id: "jm008-3", title: "第 03 卷 天台演奏会", format: "ZIP", size: "146 MB", date: "2024-10-02" },
      { id: "jm008-2", title: "第 02 卷 迟到的主唱", format: "ZIP", size: "141 MB", date: "2024-07-11" },
      { id: "jm008-1", title: "第 01 卷 空教室的旋律", format: "PDF", size: "84 MB", date: "2024-04-27" },
    ],
  },
  {
    id: "jm009",
    title: "深渊回响",
    author: "A. Marlowe",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20lone%20figure%20descending%20into%20a%20dark%20abyss%20with%20glowing%20eyes%2C%20deep%20teal%20and%20black%20palette%20with%20amber%20shadows%2C%20clean%20minimal%20background%2C%20eerie%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-09&orientation=portrait",
    categories: ["kongbu", "xuanyi"],
    region: "欧美",
    status: "连载中",
    year: 2023,
    updateDate: "2024-09-05",
    downloads: 47890,
    rating: 8.9,
    summary: "深海考察站传来一段无法解释的录音，每一句低语都像从深渊里爬出来。当队员开始一个个消失，恐惧才真正降临。",
    tags: ["悬疑", "心理", "惊悚"],
    chapters: [
      { id: "jm009-3", title: "第 03 卷 消失的第七人", format: "ZIP", size: "160 MB", date: "2024-09-05" },
      { id: "jm009-2", title: "第 02 卷 低语磁带", format: "ZIP", size: "149 MB", date: "2024-06-14" },
      { id: "jm009-1", title: "第 01 卷 下潜", format: "PDF", size: "87 MB", date: "2024-03-22" },
    ],
  },
  {
    id: "jm010",
    title: "机械纪元编年史",
    author: "方一鸣",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20giant%20mecha%20robot%20standing%20in%20a%20ruined%20futuristic%20city%2C%20steel%20blue%20and%20amber%20accents%2C%20clean%20minimal%20background%2C%20epic%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-10&orientation=portrait",
    categories: ["kehuan"],
    region: "中国",
    status: "连载中",
    year: 2021,
    updateDate: "2024-06-30",
    downloads: 70120,
    rating: 8.8,
    summary: "人类与机械共存的年代走到了尽头。少年驾驶着最后一台遗产机甲，试图在文明崩塌前，为两个种族找到第三条路。",
    tags: ["机甲", "战争", "长篇"],
    chapters: [
      { id: "jm010-4", title: "第 04 卷 遗产启动", format: "ZIP", size: "210 MB", date: "2024-06-30" },
      { id: "jm010-3", title: "第 03 卷 钢铁之雨", format: "ZIP", size: "203 MB", date: "2024-03-08" },
      { id: "jm010-2", title: "第 02 卷 停战协议", format: "PDF", size: "108 MB", date: "2023-11-26" },
      { id: "jm010-1", title: "第 01 卷 最后一台", format: "ZIP", size: "172 MB", date: "2023-08-15" },
    ],
  },
  {
    id: "jm011",
    title: "笑点生成器",
    author: "冈本 拓",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20funny%20cartoon%20characters%20reacting%20in%20exaggerated%20ways%2C%20bright%20yellow%20orange%20and%20white%20palette%2C%20clean%20minimal%20background%2C%20playful%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-11&orientation=portrait",
    categories: ["gaoxiao", "richang"],
    region: "日本",
    status: "已完结",
    year: 2022,
    updateDate: "2023-12-20",
    downloads: 62150,
    rating: 8.5,
    summary: "一个专治不开心的小镇，一台故障不断的快乐机器。每翻一页都有一个让你笑出声的荒诞日常。",
    tags: ["搞笑", "四格", "解压"],
    chapters: [
      { id: "jm011-2", title: "第 02 卷 故障现场", format: "ZIP", size: "128 MB", date: "2023-12-20" },
      { id: "jm011-1", title: "第 01 卷 快乐开机", format: "PDF", size: "76 MB", date: "2023-09-09" },
    ],
  },
  {
    id: "jm012",
    title: "极地远征队",
    author: "L. Bennett",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20expedition%20team%20crossing%20a%20frozen%20ice%20field%20with%20snow%20peaks%2C%20icy%20blue%20white%20and%20amber%20sun%20palette%2C%20clean%20minimal%20background%2C%20adventurous%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-12&orientation=portrait",
    categories: ["maoxian"],
    region: "欧美",
    status: "连载中",
    year: 2024,
    updateDate: "2024-08-19",
    downloads: 44380,
    rating: 8.6,
    summary: "地图的边缘之外，是没有人抵达过的白色荒原。一支远征队带着最后的补给出发，去寻找传说中不会结冰的海。",
    tags: ["探险", "生存", "未知"],
    chapters: [
      { id: "jm012-3", title: "第 03 卷 白色荒原", format: "ZIP", size: "158 MB", date: "2024-08-19" },
      { id: "jm012-2", title: "第 02 卷 补给危机", format: "ZIP", size: "151 MB", date: "2024-05-28" },
      { id: "jm012-1", title: "第 01 卷 出发前夜", format: "PDF", size: "90 MB", date: "2024-02-06" },
    ],
  },
  {
    id: "jm013",
    title: "妖怪旅馆奇谭",
    author: "森野 结",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20traditional%20japanese%20inn%20with%20friendly%20spirits%20and%20lanterns%20at%20night%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20clean%20minimal%20background%2C%20cozy%20mystical%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-13&orientation=portrait",
    categories: ["qihuan", "richang"],
    region: "日本",
    status: "连载中",
    year: 2023,
    updateDate: "2024-07-04",
    downloads: 53760,
    rating: 9.0,
    summary: "深山里的老旅馆只在黄昏后接待客人，而客人大多不是人类。年轻的掌柜要学会的第一课，是如何与妖怪打交道。",
    tags: ["妖怪", "治愈", "和风"],
    chapters: [
      { id: "jm013-3", title: "第 03 卷 雪女的晚宴", format: "ZIP", size: "150 MB", date: "2024-07-04" },
      { id: "jm013-2", title: "第 02 卷 客人请留步", format: "ZIP", size: "144 MB", date: "2024-04-10" },
      { id: "jm013-1", title: "第 01 卷 黄昏开门", format: "PDF", size: "86 MB", date: "2024-01-16" },
    ],
  },
  {
    id: "jm014",
    title: "冠军之路",
    author: "周予安",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20young%20athlete%20sprinting%20towards%20a%20finish%20line%2C%20dynamic%20motion%2C%20crimson%20and%20navy%20palette%2C%20clean%20minimal%20background%2C%20triumphant%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-14&orientation=portrait",
    categories: ["rexue"],
    region: "中国",
    status: "连载中",
    year: 2022,
    updateDate: "2024-09-12",
    downloads: 76450,
    rating: 8.9,
    summary: "被淘汰过三次的少年，用一双旧跑鞋重新站上跑道。他要证明的不是天赋，而是每一次跌倒后还能再跑一步的倔强。",
    tags: ["竞技", "励志", "少年"],
    chapters: [
      { id: "jm014-4", title: "第 04 卷 决赛枪响", format: "ZIP", size: "166 MB", date: "2024-09-12" },
      { id: "jm014-3", title: "第 03 卷 逆风冲刺", format: "ZIP", size: "159 MB", date: "2024-06-02" },
      { id: "jm014-2", title: "第 02 卷 第二双鞋", format: "PDF", size: "89 MB", date: "2024-02-25" },
      { id: "jm014-1", title: "第 01 卷 起跑线", format: "ZIP", size: "155 MB", date: "2023-11-11" },
    ],
  },
  {
    id: "jm015",
    title: "暮色恋歌",
    author: "박하늘",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20romantic%20couple%20silhouette%20against%20a%20magical%20sunset%20sky%20with%20floating%20lights%2C%20rose%20pink%20and%20deep%20violet%20accent%20palette%2C%20clean%20minimal%20background%2C%20dreamy%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-15&orientation=portrait",
    categories: ["lianai", "qihuan"],
    region: "韩国",
    status: "已完结",
    year: 2021,
    updateDate: "2023-06-28",
    downloads: 69580,
    rating: 9.1,
    summary: "只有在黄昏才会出现的神秘少年，与能看见暮色之光的少女。他们的相遇，是一场跨越时间的约定。",
    tags: ["奇幻", "浪漫", "已完结"],
    chapters: [
      { id: "jm015-3", title: "第 03 卷 暮色尽头", format: "ZIP", size: "147 MB", date: "2023-06-28" },
      { id: "jm015-2", title: "第 02 卷 光的约定", format: "ZIP", size: "142 MB", date: "2023-03-15" },
      { id: "jm015-1", title: "第 01 卷 看得见的光", format: "PDF", size: "83 MB", date: "2022-12-01" },
    ],
  },
  {
    id: "jm016",
    title: "第七码头的秘密",
    author: "윤재하",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20old%20harbor%20pier%20at%20dusk%20with%20a%20shrouded%20figure%20and%20cargo%20crates%2C%20moody%20teal%20and%20amber%20palette%2C%20clean%20minimal%20background%2C%20mysterious%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-16&orientation=portrait",
    categories: ["xuanyi"],
    region: "韩国",
    status: "连载中",
    year: 2024,
    updateDate: "2024-09-30",
    downloads: 41230,
    rating: 8.7,
    summary: "港口城市最古老的第七码头，三年来每晚都有同一艘船靠岸，却从未有人下船。记者开始调查，却发现所有人都在说谎。",
    tags: ["悬疑", "犯罪", "都市"],
    chapters: [
      { id: "jm016-3", title: "第 03 卷 沉默的货单", format: "ZIP", size: "153 MB", date: "2024-09-30" },
      { id: "jm016-2", title: "第 02 卷 无人下船", format: "ZIP", size: "148 MB", date: "2024-07-07" },
      { id: "jm016-1", title: "第 01 卷 记者的笔记", format: "PDF", size: "85 MB", date: "2024-04-15" },
    ],
  },
  {
    id: "jm017",
    title: "幻境猎人",
    author: "相泽 律",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20hunter%20with%20a%20glowing%20bow%20standing%20before%20a%20magical%20portal%2C%20emerald%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20fantasy%20adventure%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-17&orientation=portrait",
    categories: ["qihuan", "maoxian"],
    region: "日本",
    status: "连载中",
    year: 2023,
    updateDate: "2024-08-25",
    downloads: 57940,
    rating: 8.8,
    summary: "幻境是现实与梦境之间的裂缝。猎人穿梭其中，驱逐失控的幻兽，也一点点找回自己遗失的记忆。",
    tags: ["奇幻", "冒险", "战斗"],
    chapters: [
      { id: "jm017-3", title: "第 03 卷 记忆的碎片", format: "ZIP", size: "161 MB", date: "2024-08-25" },
      { id: "jm017-2", title: "第 02 卷 失控的幻兽", format: "ZIP", size: "154 MB", date: "2024-05-31" },
      { id: "jm017-1", title: "第 01 卷 裂缝初开", format: "PDF", size: "91 MB", date: "2024-03-09" },
    ],
  },
  {
    id: "jm018",
    title: "放课后科学社",
    author: "手冢 望",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20anime%20manga%20cover%20illustration%2C%20students%20in%20a%20school%20science%20club%20room%20with%20bubbling%20experiments%20and%20gadgets%2C%20fresh%20green%20and%20cream%20palette%2C%20clean%20minimal%20background%2C%20cheerful%20mood%2C%20digital%20art&width=600&height=800&seq=jm-cover-18&orientation=portrait",
    categories: ["xiaoyuan", "kehuan"],
    region: "日本",
    status: "已完结",
    year: 2020,
    updateDate: "2022-11-30",
    downloads: 48620,
    rating: 8.4,
    summary: "一个只有三名成员的濒临解散的科学社，为了保住社团教室，决定用一个假期做出惊天动地的发明——结果真的出事了。",
    tags: ["校园", "轻科幻", "已完结"],
    chapters: [
      { id: "jm018-2", title: "第 02 卷 暑假大实验", format: "ZIP", size: "138 MB", date: "2022-11-30" },
      { id: "jm018-1", title: "第 01 卷 保住社团教室", format: "PDF", size: "80 MB", date: "2022-08-20" },
    ],
  },
];